<template>
  <div class="Sidebar">
    <ul class="Sidebar_ul">
      <li class="ul_item">
        <h3 class="item_title" :class="{active: currentlyBelongsTo === 'LaunchPlan'}">投放计划</h3>
        <div class="minorItems">
          <span class="minorItems_text">推广目标</span>
          <i class="minorItems_icon">√</i>
        </div>
        <div class="minorItems">
          <span class="minorItems_text">投放位置</span>
          <i class="minorItems_icon">√</i>
        </div>
        <div class="minorItems">
          <span class="minorItems_text">购买方式</span>
          <i class="minorItems_icon">√</i>
        </div>
      </li>
      <li class="ul_item">
        <h3 class="item_title" :class="{active: currentlyBelongsTo === 'Advertisement'}">广告</h3>
        <div class="minorItems">
          <span class="minorItems_text">时间</span>
          <i class="minorItems_icon">√</i>
        </div>
        <div class="minorItems">
          <span class="minorItems_text">定向</span>
          <i class="minorItems_icon">√</i>
        </div>
        <div class="minorItems">
          <span class="minorItems_text">预算</span>
          <i class="minorItems_icon">√</i>
        </div>
      </li>
      <li class="ul_item">
        <h3 class="item_title" :class="{active: currentlyBelongsTo === 'originality'}">创意</h3>
        <div class="minorItems">
          <span class="minorItems_text">创意</span>
          <i class="minorItems_icon">√</i>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    currentlyBelongsTo: {
      type: String
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="less">
.Sidebar {
  width: 168px;
  min-width: 168px;
  height: 100%;
  font-size: 13px;
  background-color: #fff;
  box-shadow: 1px 0 0 0 rgb(0 0 0 / 6%);
  position: relative;
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0px;
  .Sidebar_ul {
    .ul_item {
      .item_title {
        margin-bottom: 19px;
        &.active{
          color: #07c160;
        }
      }
      .minorItems {
        padding: 8px 21px;
        position: relative;
        &::before {
          top: 50%;
          left: 6px;
          margin-top: -0.5px;
          width: 10px;
          height: 1px;
          content: '';
          position: absolute;
          background-color: #d3d4d6;
        }
        &::after {
          left: 6px;
          top: -14px;
          width: 1px;
          height: 28px;
          content: '';
          position: absolute;
          background-color: #d3d4d6;
        }
        .minorItems_text {
        }
        .minorItems_icon {
          font-style: normal;
          position: absolute;
          right: -15px;
          font-size: 15px;
        }
      }
    }
  }
}
</style>
